module.exports = "./img/desktop_logo.4706c99.png";